export const OutputErrorCode = {
    UNDERAGE: 'UNDERAGE',
    BACKOFFICE: 'BACKOFFICE',
    INSUFFICIENTDATA: 'INSUFFICIENTDATA',
    CIPWITHOUTACCOUNT: 'CIPWITHOUTACCOUNT',
    CIPUNAUTHENTICATED: 'CIP_UNAUTHENTICATED',
    DATADONTMATCH: 'DATADONTMATCH',
    EXPIREDTOKEN: 'EXPIREDTOKEN',
    FAILEDVALIDATION: 'FAILEDVALIDATION',
    INVALIDTOKEN: 'INVALIDTOKEN',
    LOGINNOTFOUND: 'LOGINNOTFOUND',
    PATIENTNOTFOUND: 'PATIENTNOTFOUND',
    UNAUTHORIZED: 'UNAUTHORIZED',
    RECAPTCHATOKENINVALID: 'RECAPTCHATOKENINVALID',
    PHONEALREADYINUSE: 'PHONEALREADYINUSE',
    EMAILALREADYINUSE: 'EMAILALREADYINUSE',
    SERVICE_ERROR_CEP_PROMISE: 'service_error',
    BACKOFFICE_ERROR: 'BACKOFFICE',
    NOTACCEPTABLE: 'NOTACCEPTABLE',
    ACCOUNTNOTFOUND: 'ACCOUNTNOTFOUND',
    NOT_ACCEPTABLE: 'NOT_ACCEPTABLE',
    LOGINFOUND: 'LOGINFOUND',
    NOTEXISTS: 'NOTEXISTS',
    INVALIDBIRTHDATE: 'INVALIDBIRTHDATE',
    DECEASED: 'DECEASED',
    FORBIDDEN: 'FORBIDDEN',
    BAD_USER_INPUT: 'BAD_USER_INPUT',
}

export const OutputErrorMsg = {
    CIPWITHOUTACCOUNT: 'Algo está errado. Revise seus dados',
    RECAPTCHATOKENINVALID: 'Ocorreu um erro ao fazer seu login. Tente novamente.',
    EXPIREDTOKEN: 'Código expirado',
    FAILEDVALIDATION: 'Senha inválida',
    INVALIDTOKEN: 'Código inválido',
    LOGINNOTFOUND: 'Login não encontrado',
    PATIENTNOTFOUND: 'Paciente não pode ser encontrado',
    UNKNOWNERROR: 'Um erro ocorreu',
    UNAUTHORIZED: 'Algo está errado. Revise seus dados.',
    UNAUTHORIZED_CPF_TRY_CIP: 'Algo está errado. Revise seus dados ou tente entrar com a CIP.',
    GENERICERROR: 'Ocorreu um erro. Tente novamente mais tarde',
    FORBIDDENERROR: 'Estamos com problemas. Tente novamente mais tarde.',
    PHONEALREADYINUSE: 'Este contato já está em uso.',
    EMAILALREADYINUSE: 'Este contato já está em uso.',
    SERVICE_ERROR_CEP_PROMISE: 'CEP não encontrado',
}
